module.exports = __webpack_public_path__ + "img/header-menu.22861a72.png";